<template>
  <div>
    <div class="pageLogin">
      <img src="../../assets/tianshi/createbj.jpg" alt class="images" />
      <div class="box-card">
        <div class="box-list">
          <div class="box-car-title">
            <div class="title1">{{ $i18n.locale == "en" ? 'Create Your Account' : $i18n.locale == "zh" ? '创建您的账户' : '. كرييت يور اكونت' }}</div>
            <div class="title2">
              <el-select v-model="language" @change="changeLanguage">
                <el-option
                  style="display: flex; align-items: center"
                  v-for="(item, index) in filterOptions"
                  :key="index"
                  :value="item.name"
                >
                  <img :src="item.src" :alt="item.name" style="width: 18px; height: 12px; margin-right: 5px" />
                  <span style="font-size: 12px">{{ item.name }}</span>
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-if="isHide">
            <el-form :model="form" ref="form" label-position="top" label-width="170px" :rules="rules">
              <el-form-item prop="userAccount" :label="$t('useraccount') + ':'">
                <template #error>
                  <div class="erro">{{ $t("inputUserAccount") }}</div>
                </template>
                <el-input v-model="form.userAccount"></el-input>
              </el-form-item>
              <el-form-item prop="userPassword" :label="$t('password') + ':'">
                <template #error>
                  <div class="erro">{{ $t("inputPassword") }}</div>
                </template>
                <el-input type="password" v-model="form.userPassword"></el-input>
              </el-form-item>
              <el-form-item prop="userName" :label="$t('username') + ':'">
                <template #error>
                  <div class="erro">{{ $t("inputUserName") }}</div>
                </template>
                <el-input v-model="form.userName"></el-input>
              </el-form-item>
              <el-form-item :label="$t('gender') + ':'">
                <el-radio v-model="form.gender" label="1">{{$t('man')}}</el-radio>
                <el-radio v-model="form.gender" label="2">{{$t('woman')}}</el-radio>
              </el-form-item>
              <el-form-item prop="mobile" :label="$t('mobile') + ':'">
                <template #error>
                  <div class="erro">{{ $t("inputMobile") }}</div>
                </template>
                <el-input v-model="form.mobile"></el-input>
              </el-form-item>
              <el-form-item prop="email" :label="$t('email') + ':'">
                <template #error>
                  <div class="erro">{{ $t("inputEmail") }}</div>
                </template>
                <el-input v-model="form.email"></el-input>
              </el-form-item>
              <el-form-item :label="$t('address') + ':'">
                <el-input v-model="form.address"></el-input>
              </el-form-item>
              <el-form-item prop="valideCode" :label="$t('vaildecode') + ':'" class="valide-code">
                <template #error>
                  <div class="erro">{{ $t("inputVaildeCode") }}</div>
                </template>
                <el-input v-model="form.valideCode"></el-input>
                <img
                  v-if="JSON.stringify(codeData) !== '{}'"
                  @click="getCode"
                  :src="codeData.valideCode"
                  title="看不清楚？换一张"
                  style="border: 1px solid gainsboro;"
                />
              </el-form-item>
            </el-form>
          </div>
          <el-button type="primary" @click="submit" class="btn">{{ $t('registration') }}</el-button>
          <div class="Login" @click="goToLogin">{{ $t("toLogin") }}</div>
        </div>
      </div>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { GetValideCode, RegisterMember } from "@/api/login";
import { setDocumentTitle } from '@/utils/domUtil'

export default {
  name: "regModal",
  data() {
    // 检验邮件
    let regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
    let checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(
            this.$t("inputEmail")
          )
        );
      }
      if (regEmail.test(value)) {
        // 合法邮箱
        callback();
      } else {
        // 错误邮箱
        callback(
          new Error(
            this.$t("inputEmailRules")
          )
        );
      }
    };
    return {
      options: [
        { name: "English", value: "en", src: require("@/assets/English.png") },
        { name: "中文", value: "zh-Hans", src: require("@/assets/China.png") },
        // {
        //   name: "русский язык",
        //   value: "ru",
        //   src: require("@/assets/Russia.png"),
        // },
        {
          name: "الصينية",
          value: "ru",
          src: require("@/assets/alibo.jpg"),
        },
      ],
      isHide: true,
      language: this.$t("language"),
      languageIcon: require("@/assets/English.png"),
      visible: false,
      codeData: "",
      form: {
        userAccount: "",
        userPassword: "",
        mobile: "",
        valideCode: "",
        email: "",
        address: "",
        userName: "",
        gender: "1"
      },
      rules: {
        userName: [
          { required: true, message: this.$t("inputUserName"), trigger: "blur" }
        ],
        email: [{ trigger: "blur", validator: checkEmail }],
        mobile: [
          { required: true, message: this.$t("inputMobile"), trigger: "blur" }
        ],
        userAccount: [
          {
            required: true,
            message: this.$t("inputUserAccount"),
            trigger: "blur"
          }
        ],
        userPassword: [
          {
            required: true,
            message: this.$t("inputPassword"),
            trigger: "blur"
          },
          { min: 6, message: this.$t("passwordLength"), trigger: "blur" }
        ],
        valideCode: [
          {
            required: true,
            message: this.$t("inputVaildeCode"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.getCode()
  },
  watch: {
    currentLanguage() {
      this.language = this.$t("language")
    }
  },
  computed: {
    ...mapGetters('setting', {
      getSetting: 'get_setting',
    }),
    ...mapState('operate', ['language']),
    filterOptions() {
      let list = ['en', 'zh-Hans', 'ru'];
      let newList = this.options.filter((item) => list.includes(item.value));
      return newList;
    },
    activeIcon() {
      return this.$t("language") == "English"
        ? this.options[0].src
        : this.$t("language") == "中文"
          ? this.options[1].src
          : this.options[2].src;
    },
    currentLanguage() {
      return this.$t("language")  // 获取当前语言
    }
  },
  methods: {
    ...mapActions('operate', {
      set_language: 'set_language'
    }),
    changeLanguage(e) {
      this.isHide = false
      if (e === "English") {
        this.$i18n.locale = "en";
        this.set_language("en");
        this.languageIcon = this.options[0].src;
        setDocumentTitle(this.getSetting.enTitle);
        // window.location.reload()
      } else if (e === "中文") {
        this.$i18n.locale = "zh";
        this.set_language("zh");
        this.languageIcon = this.options[1].src;
        setDocumentTitle(this.getSetting.title);
        // window.location.reload()
      } else if (e === "الصينية") {
        this.$i18n.locale = "ru";
        this.set_language("ru");
        this.languageIcon = this.options[2].src;
        setDocumentTitle(this.getSetting.rusTitle);
      }
      this.$nextTick(() => {
        this.isHide = true
      })
    },
    open() {
      this.visible = true;
      this.getCode();
    },
    close() {
      this.visible = false;
      this.form.address = "";
      this.$refs.form.resetFields();
    },
    submit() {
      let _this = this;
      _this.$refs.form.validate(values => {
        if (!values) return false;

        // 注册
        RegisterMember({ ..._this.form, keyCode: _this.codeData.keyCode })
          .then(() => {
            _this.$message.success(_this.$t("regSuccess"));
            _this.close();
          })
          .catch(err => {
            if (err.includes("D1632") || err.includes("D1631")) {
              _this.$message.error(_this.$t("CodeError"));
            } else if (err.includes("D1630")) {
              this.$message.error(_this.$t("resUserError"));
            }
            _this.getCode();
          });
      });
    },
    // 去登录
    goToLogin() {
      this.close();
      this.$router.push("/loginIn")
    },
    // 获取验证码
    getCode() {
      GetValideCode()
        .then(res => {
          this.codeData = res.data;
        })
        .catch(err => {
          this.$message.error(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.pageLogin {
  background-color: #ffffff;
  justify-content: center;
  background-repeat: no-repeat; /* 设置背景图片不重复 */
  background-size: cover; /* 确保背景图片覆盖整个元素 */
  height: 1050px;
  .images {
    position: absolute;
    z-index: 99;
    width: 100%;
  }
}

.box-card {
  width: 500px;
  height: 957px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 83px;
  z-index: 999;
  .box-list {
    width: 440px;
    margin-top: 47px;
  }
  .box-car-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    .title1 {
      font-size: 24px;
      font-weight: 500;
      color: #222222;
    }
    .title2 {
      font-size: 14px;
      font-weight: 400;
      color: #b2b2b2;
    }
    :deep(.el-input__inner) {
      font-size: 14px;
      width: 95px;
      border: none;
      background-color: #ffffff;
    }
  }
  .Login {
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    color: #424245;
    &:hover {
      color: #ff760e;
    }
  }
}

:deep .el-form {
  .valide-code {
    .el-input {
      margin: 0 10px 0 0;
    }
    .el-form-item__content {
      display: flex;
    }
  }
  .el-form-item {
    margin-bottom: 4px !important;
  }
}

:deep .el-form--label-top .el-form-item__label {
  padding: 0px !important;
}

.Registration {
  text-align: center;
  cursor: pointer;

  &:hover {
    color: #d871b8;
  }
}

button {
  width: 300px;
  background-color: #d871b8;
  border-color: #d871b8;

  &:hover {
    background-color: #d871b8;
    border-color: #d871b8;
  }
}

// display: flex;
.btn {
  margin-bottom: 20px;
  width: 440px;
  height: 42px;
  background: #d871b8;
  border: 1px solid #d871b8;
  margin-top: 40px;
}
.erro {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
</style>